module.exports = __webpack_public_path__ + "img/add.30156af4.svg";